import { colors } from "@material-ui/core";
import { GET_ENTIRE_USER_DATA_RESUME, ADD_SKILL, UPDATE_SKILL, DELETE_SKILL, ADD_HOBBY, UPDATE_HOBBY, DELETE_HOBBY, PHOTO_PRIVACY,CERTIFICATE_PRIVACY,EDUCATION_PRIVACY,WORK_PRIVACY,PROJECT_PRIVACY,PUBLICATION_PRIVACY,ORENTATION_RESUME,BACKGROUND_RESUME } from "../constants";

const initialResumeData = {
    title: '',
    personalDetail: {
        city: "",
        country: "",
        email: { emailDisplay: '', isHidden: true },
        fullName: "",
        phone: { phoneDisplay: '', isHidden: true },
        photo: { link: '', isHidden: true },
        postcode: "",
        social: [],
        street: "",
        address: { addressDisplay: '', isHidden: true }
    },
    educationDetail: [],
    publicationDetail: [],
    certificateDetail: [],
    extracurricularDetail: [],
    workDetail: [],
    projectDetail: [],
    skills: [],
    intrests: [],
    languageCode: 'en',
    design: {
        layout: { layoutName: 'dividerHalf', orientation: 'left', background: '#48a9a6' },
        colors: ['#193141', '#48a9a6', '#8ddddd','#000000','#475e65','#d9ae89','#86263c','#0f453d','#1e233f']
    }
}


const resumeReducer = (state = initialResumeData, action) => {
    switch (action.type) {
        case GET_ENTIRE_USER_DATA_RESUME: {
            const { personalDetail } = state
            const { profile_data, education_data, certificate_data, extracuricular_data, projects_data, publication_data, work_data } = action.payload
            const storageData = JSON.parse(localStorage.getItem('state'))
            state.title = storageData.title
            personalDetail.fullName = profile_data.fname + ' ' + profile_data.lname
            personalDetail.city = profile_data.city
            personalDetail.country = profile_data.country
            personalDetail.postcode = profile_data.pincode
            personalDetail.email = { emailDisplay: profile_data.email, isHidden: true }
            personalDetail.phone = { phoneDisplay: profile_data.phone, isHidden: true }
            personalDetail.photo = { link: profile_data.profile_photo, isHidden: true }
            personalDetail.bio = { bioDisplay: profile_data.bio, isHidden: true }
            personalDetail.address = { addressDisplay: `${profile_data.city}, ${profile_data.pincode}, ${profile_data.country}`, isHidden: true }
            state.educationDetail = education_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            state.certificateDetail = certificate_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            state.extracurricularDetail = extracuricular_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            state.projectDetail = projects_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            state.publicationDetail = publication_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            state.workDetail = work_data.map((data) => {
                return { isHidden: true, entries: data };
            });
            return {
                ...state
            }
        }
        case ADD_SKILL: {
            const { skill, skillLevel } = action.payload
            if (state.skills.length < 6) {
                state.skills.push({
                    skill: skill,
                    skillLevel: skillLevel,
                    skillLevelRate: skillLevel === 'Novice' ? 1 : skillLevel === 'Beginner' ? 2 : skillLevel === 'Skillful' ? 3 : skillLevel === 'Experienced' ? 4 : skillLevel === 'Expert' ? 5 : ''
                });
            } else {
                alert("Only 6 skills are allowed");
            }
            return {
                ...state
            }
        }
        case UPDATE_SKILL: {
            const { selectedId, skill, skillLevel } = action.payload
            state.skills[selectedId].skill = skill
            state.skills[selectedId].skillLevel = skillLevel
            state.skills[selectedId].skillLevelRate = skillLevel === 'Novice' ? 1 : skillLevel === 'Beginner' ? 2 : skillLevel === 'Skillful' ? 3 : skillLevel === 'Experienced' ? 4 : skillLevel === 'Expert' ? 5 : ''
            return {
                ...state
            }
        }
        case DELETE_SKILL: {
            state.skills.splice(action.payload, 1)
            return {
                ...state
            }
        }
        case ADD_HOBBY: {
            const { hobby } = action.payload
            if (state.intrests.length < 6) {
                state.intrests.push({
                    interest: hobby,
                });
            } else {
                alert("Only 6 skills are allowed");
            }
            return {
                ...state
            }
        }
        case UPDATE_HOBBY: {
            const { selectedId, hobby } = action.payload
            state.intrests[selectedId].interest = hobby
            return {
                ...state
            }
        }
        case DELETE_HOBBY: {
            state.intrests.splice(action.payload, 1)
            return {
                ...state
            }
        }
        case PHOTO_PRIVACY: {
            const { personalDetail } = state
            personalDetail.photo.isHidden = action.payload === 'show' ? false : true
            return {
                ...state
            }
        }
        case CERTIFICATE_PRIVACY: {
            const { selectedId, value} = action.payload
            state.certificateDetail[selectedId].isHidden = value === 'show' ? false : true
            return {
                ...state
            }
        }
        case EDUCATION_PRIVACY: {
            const { selectedId, value} = action.payload
            state.educationDetail[selectedId].isHidden = value === 'show' ? false : true
            return {
                ...state
            }
        }
        case WORK_PRIVACY: {
            const { selectedId, value} = action.payload
            state.workDetail[selectedId].isHidden = value === 'show' ? false : true
            return {
                ...state
            }
        }
        case PROJECT_PRIVACY: {
            const { selectedId, value} = action.payload
            state.projectDetail[selectedId].isHidden = value === 'show' ? false : true
            return {
                ...state
            }
        }
        case PUBLICATION_PRIVACY: {
            const { selectedId, value} = action.payload
            state.publicationDetail[selectedId].isHidden = value === 'show' ? false : true
            return {
                ...state
            }
        }
        case ORENTATION_RESUME: {
            const {design} = state
            design.layout.orientation = action.payload
            return {
                ...state
            }
        }
        case BACKGROUND_RESUME: {
            const {design} = state
            design.layout.background = action.payload
            return {
                ...state
            }
        }
        default: return state;
    }
}


export default resumeReducer;